<ng-container *ngIf="showSuccessModal">
	<app-web-kamona-message-widget
		[modalType]="ModalType.CUSTOM">
		<ng-container>
			<ng-container *ngTemplateOutlet="successTemplate"></ng-container>
		</ng-container>
	</app-web-kamona-message-widget>
</ng-container>

<ng-container *ngIf="isModal">
	<app-web-kamona-message-widget
		[title]="modalTitle"
		[iconType]="iconType"
		[btnText]="btnText"
		[btnType]="btnType"
		(emitCancel)="setModal(false)"
		[description]="modalDescription">
	</app-web-kamona-message-widget>
</ng-container>

<div class="device-reg-wrapper">
	<div class="bg-color bg-properties">
		<div class="max-w-[1196px] flex grow flex-col">
			<ng-container *ngTemplateOutlet="header"></ng-container>
			<div class="grow">
				<ng-container *ngTemplateOutlet="body"></ng-container>
			</div>
			<ng-container *ngTemplateOutlet="footer"></ng-container>
		</div>
	</div>
</div>

<ng-template #body>
	<div class="mt-[100px] mx-auto max-w-[936px] gap-16 flex justify-center">
		<div class="basis-1/2">
			<div class="flex flex-col gap-[18px] max-w-[402px]">
				<div class="text-black leading-[44.64px] font-bold text-[36px]">Register Device</div>
				<div class="text-[#666666] leading-[22.4px] font-medium">Please confirm you own this device</div>
			</div>
		</div>
		<div class="grow basis-1/2">
			<ng-container *ngTemplateOutlet="idVerification"></ng-container>
		</div>
	</div>
</ng-template>


<ng-template #footer>
	<div class="max-w-[939px] mx-auto pb-[43px] w-full text-[14px] font-medium text-[#808080] leading-[17.36px]">
		<div class="flex justify-between">
			<div *ngIf="false" class="flex gap-[16px] basis-1/2">
				<div class="text-white">About Moniepoint</div>
				<div class="cursor-pointer text-white" (click)="openPrivacy()">Privacy</div>
				<div class="cursor-pointer text-white" (click)="openTermsAndConditions()">Terms & Conditions</div>
			</div>
			<div class="basis-1/2">
				<div *ngIf="false" class="flex gap-[16px] justify-end">
					<div>Having any troubles?</div>
					<div class="text-[#0361F0]">Get Help</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>
<ng-template #header>
	<div class="mt-[30px] w-full flex justify-between items-center">
		<div>
			<img src="assets/images/svgs/moniepoint-icon-and-label.svg">
		</div>
		<div class="flex gap-[12px] items-center">
			<div  class="text-[14px] leading-[19.6px] cursor-pointer text-black font-normal">
				Already have an account?
			</div>
			<div (click)="goToLogin()" class="bg-[#E6EEFD] cursor-pointer h-[46px] w-[137px] items-center flex justify-center rounded-[8px] py-[11px] px-[16px]">
				<div class="leading-[17.36px] text-[14px] font-medium text-[#0361F0]">
					Login
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #idVerification>
	<ng-container *ngIf="livelinessRequired else livelinessNotRequiredTemplate">
		<ng-container *ngTemplateOutlet="livelinessRequiredTemplate"></ng-container>
	</ng-container>
</ng-template>

<ng-template #livelinessNotRequiredTemplate>
	<div class="custom-web-form-container">
		<app-web-kamona-otp-widget
			(emitBack)="goToLogin()"
			btnText="Next"
			[ussd]="ussdCode"
			[phoneNumber]="phoneNumber"
			(emitReload)="goToLogin()"
			[minHeight]="289"
			[hideBackBtn]="true"
			[submitting]="submitting"
			(emitSubmit)="handleOtpResponse($event)"
			description=""
			title="Enter OTP">
		</app-web-kamona-otp-widget>
	</div>
</ng-template>

<ng-template #livelinessRequiredTemplate>
	<ng-container>
			<app-web-kamona-liveliness-widget
				(emitBack)="goToLogin()"
				[flowId]="flowId"
				[metaMapReference]="reference"
				[submitting]="submitting"
				[identityProvider]="provider"
				(emitFinishedMetamapVerification)="handleFinishedMetaMapVerification()"
				(emitFinishedSmileIDVerification)="submitSmileIDJob($event)">
			</app-web-kamona-liveliness-widget>
		</ng-container>
	<ng-container *ngIf="processVerification">
			<app-web-kamona-id-verification
				(emitVerifiedIdentity)="handleVerifiedIdentity($event)"
				(emitFailedIdentity)="handleFailedIdentity($event)"
				[verificationPayload]="verificationPayload"
				[verificationUrl]="idVerificationUrl">
			</app-web-kamona-id-verification>
		</ng-container>
</ng-template>

<ng-template #successTemplate>
	<div class="flex flex-col pt-[24px] px-[16px] gap-[32px]">
		<div class="flex justify-center">
			<svg width="126" height="125" viewBox="0 0 126 125" fill="none" xmlns="http://www.w3.org/2000/svg">
				<circle cx="63" cy="62.5" r="62.5" fill="#BCE8C0"/>
				<circle cx="63" cy="62.5" r="49.5" fill="#1EB12D"/>
				<circle cx="63" cy="62.5" r="38.5" fill="#18902C"/>
				<path d="M44.2568 62.3746C45.5984 61.0728 47.7719 61.0708 49.1152 62.3701L54.8122 67.8796C55.2513 68.3046 55.962 68.3042 56.4011 67.8783L75.8649 48.9803C77.2149 47.67 79.4044 47.6737 80.7494 48.9885C82.0868 50.2972 82.0834 52.4098 80.7401 53.7136L59.3257 74.5046C57.2717 76.4985 53.9425 76.4985 51.8884 74.5046L44.2568 67.0956C42.9144 65.7918 42.9144 63.6783 44.2568 62.3746Z" fill="white"/>
			</svg>
		</div>
		<div class="flex flex-col gap-[12px]">
			<div class="leading-[39.68px] text-black text-[32px] font-bold">New device registered</div>
			<div class="leading-[17.76px] text-[#333333] text-[12px] font-bold">Device Registration successful</div>
		</div>
		<div class="pt-[32px] flex items-center">
			<div class="grow">
					<div (click)="goToDashboard()" class="bg-[#0361F0] py-[6px] h-[48px] px-[16px] rounded-[8px] flex items-center justify-center cursor-pointer text-white leading-[17.36px] text-[14px] font-medium">
						Goto Dashboard
					</div>
				</div>
		</div>
	</div>
</ng-template>
